import React from 'react';
import { Link } from 'components/ui';
import StarRating from 'components/StarRating/StarRating';
import localeUtils from 'utils/LanguageLocale';
import { wrapFunctionalComponent } from 'utils/framework';
import numberUtils from 'utils/Number';
import anaConsts from 'analytics/constants';
import processEvent from 'analytics/processEvent';
import UI from 'utils/UI';
import mediaUtils from 'utils/Media';
import ReviewsAnchorDropDown from 'components/ProductPage/ReviewsAnchor/ReviewsAnchorDropDown/ReviewsAnchorDropDown.f.jsx';
import helpersUtils from 'utils/Helpers.js';
import ReviewsAnchorEN from 'components/ProductPage/ReviewsAnchor/locales/ReviewsAnchor_en_US.js';
import ReviewsAnchorFR from 'components/ProductPage/ReviewsAnchor/locales/ReviewsAnchor_fr_CA.js';

const { Media } = mediaUtils;
const { deferTaskExecution } = helpersUtils;

const { getLocalisedDataFromResource } = localeUtils;
const { formatReviewCount } = numberUtils;

const ReviewsAnchor = props => {
    const getText = getLocalisedDataFromResource(ReviewsAnchorEN, ReviewsAnchorFR);

    const clickHandler = e => {
        e.preventDefault();
        deferTaskExecution(() => {
            processEvent.process(anaConsts.LINK_TRACKING_EVENT, {
                data: {
                    eventStrings: ['event71'],
                    linkName: 'D=c55',
                    actionInfo: 'jumplink:ratings and reviews'
                }
            });
            UI.scrollTo({ elementId: 'ratings-reviews-container' });
        });
    };

    const {
        rating, showAddDropDownReviewSection, reviewStatistics, initialTotalReviews, showProsAndCons, currentProduct
    } = props;
    let { reviews } = props;
    reviews = reviews === undefined ? 0 : reviews;
    const formattedReviewCount = formatReviewCount(reviews);

    const anchorContent =
        reviews > 0 ? (
            <React.Fragment>
                <StarRating rating={rating} />
                <span
                    data-at={Sephora.debug.dataAt('number_of_reviews')}
                    css={[styles.count, styles.textOffset]}
                    children={getText('reviewsLabel', [formattedReviewCount, reviews])}
                />
            </React.Fragment>
        ) : (
            <span css={styles.textOffset}>{getText('writeReview')}</span>
        );

    const dropdownContent =
        showAddDropDownReviewSection && reviews > 0 ? (
            <ReviewsAnchorDropDown
                reviews={reviews}
                rating={rating}
                formattedReviewCount={formattedReviewCount}
                reviewStatistics={reviewStatistics}
                initialTotalReviews={initialTotalReviews}
                showProsAndCons={showProsAndCons}
                currentProduct={currentProduct}
                clickHandler={clickHandler}
            />
        ) : null;

    return (
        <React.Fragment>
            <Media greaterThan='xs'>
                <div css={styles.wrapper}>
                    <Link
                        href='#ratings-reviews-container'
                        onClick={clickHandler}
                        display='flex'
                    >
                        {anchorContent}
                    </Link>
                    {dropdownContent}
                </div>
            </Media>
            <Media at='xs'>
                <div css={styles.wrapper}>
                    <Link
                        href='#ratings-reviews-container'
                        onClick={clickHandler}
                        display='flex'
                    >
                        {anchorContent}
                    </Link>
                    {dropdownContent}
                </div>
            </Media>
        </React.Fragment>
    );
};

const styles = {
    wrapper: {
        display: 'flex',
        alignItems: 'center'
    },
    count: {
        fontWeight: 'var(--font-weight-bold)',
        marginLeft: '.4em'
    },
    textOffset: {
        position: 'relative',
        top: '.09em'
    }
};

export default wrapFunctionalComponent(ReviewsAnchor, 'ReviewsAnchor');
